import React from 'react';

/**
 * Thumb-reachable action dock on mobile and tablet, actions card in the sticky
 * left rail on desktop. Same DOM in both cases, repositioned by CSS.
 *
 * Spectators never see it, and it disappears once the match is over.
 */
function MatchActionDock({
    isPreMatch,
    substitutionLabel,
    substitutionHint,
    substitutionAriaLabel,
    isSubstitutionDisabled,
    onSubstitutionClick,
    tacticHint,
    isTacticDisabled,
    onTacticClick
}) {
    return (
        <div className="mx-dock" data-testid="match-action-dock" data-pre-match={isPreMatch ? 'true' : 'false'}>
            <button
                type="button"
                className="mx-dock__btn mx-dock__btn--primary substitution_btn"
                onClick={onSubstitutionClick}
                disabled={isSubstitutionDisabled}
                aria-label={substitutionAriaLabel}
            >
                <span className="mx-dock__label">{substitutionLabel}</span>
                <span className="mx-dock__hint">{substitutionHint}</span>
            </button>

            <button
                type="button"
                className="mx-dock__btn mx-dock__btn--ghost tactic_btn"
                onClick={onTacticClick}
                disabled={isTacticDisabled}
                aria-label="Change Tactic"
            >
                <span className="mx-dock__label">Change Tactic</span>
                <span className="mx-dock__hint">{tacticHint}</span>
            </button>
        </div>
    );
}

export default MatchActionDock;
